import { render } from "./HospitalSettings.vue?vue&type=template&id=128456e1&scoped=true"
import script from "./HospitalSettings.vue?vue&type=script&lang=js"
export * from "./HospitalSettings.vue?vue&type=script&lang=js"

import "./HospitalSettings.vue?vue&type=style&index=0&id=128456e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128456e1"]])

export default __exports__